module.exports = __webpack_public_path__ + "static/media/Tom Lee.6741493e.png";